module.exports = __webpack_public_path__ + "static/img/people2.c94346d1.png";